import { render, staticRenderFns } from "./QuickbookLogs.vue?vue&type=template&id=92d06992"
import script from "./QuickbookLogs.vue?vue&type=script&lang=js"
export * from "./QuickbookLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports